import { getApiBaseUrl } from '../constants/environment';
import type { RiftboundCard } from '../types';

/** Aggregate distinct-definition counts by rarity for one set (paginates /api/cards). */
export async function fetchCatalogRarityCountsForSet(setCode: string): Promise<Record<string, number>> {
  const base = getApiBaseUrl();
  const counts: Record<string, number> = {};
  let page = 1;
  for (;;) {
    const params = new URLSearchParams({
      set: setCode,
      page: String(page),
      pageSize: '80',
    });
    const r = await fetch(`${base}/api/cards?${params.toString()}`);
    if (!r.ok) break;
    const data = (await r.json()) as {
      cards: RiftboundCard[];
      pagination: { hasMore: boolean };
    };
    for (const c of data.cards || []) {
      const rr = c.rarity?.trim() ? c.rarity : 'Unknown';
      counts[rr] = (counts[rr] || 0) + 1;
    }
    if (!data.pagination?.hasMore) break;
    page += 1;
    if (page > 200) break;
  }
  return counts;
}
